<!--
  This is a temporary component to display the benchmark Remediation Kit items in a test page.
-->
<template>
  <div v-if="items && items.length > 0">
    <div v-for="item in items" :key="item.remediationKitTitle">
      <sc-text :field="item.remediationKitTitle" />
      <sc-text :field="item.remediationKitFileName" />
      <sc-text :field="item.remediationKitLocation" />
    </div>
  </div>
</template>

<script>
import { Text } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Resource-Benchmark-RemediationKit',
  props: {
    items: {
      type: Array
    }
  },
  components: {
    ScText: Text
  }
};
</script>
